var map = {
	"./banner.json": "cb06",
	"./common.json": "5639",
	"./file.json": "d32c",
	"./product.json": "6041",
	"./resource.json": "d5d3",
	"./signIn.json": "e79d",
	"./translation.json": "fea2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "05b1";